<template>
  <ul
    v-if="footerNav"
    class="c-mobile-nav-footer"
  >
    <li
      v-for="(navItem, index) in footerNav.navItems"
      :key="'j-mobile-nav-footer_' + index"
      class="c-mobile-nav-footer__item"
    >
      <a
        v-if="navItem.linkUrl.startsWith('http')"
        :href="navItem.linkUrl"
        :tabindex="tabindexStart+index"
        class="c-mobile-nav-footer__item-link t-heading-6"
      >
        {{ navItem.linkText }}
      </a>
      <nuxt-link
        v-else
        class="c-mobile-nav-footer__item-link t-heading-6"
        :to="navItem.linkUrl"
        :tabindex="tabindexStart+index"
      >
        {{ navItem.linkText }}
      </nuxt-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "MobileFooterNav",
  props:{
    tabindexStart:{
      type: Number,
      default: 0
    },
    footerNav:{
      type: Object,
      default: null
    }
  },
  data(){
    return {

    }
  },
  mounted(){

  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
  .c-mobile-nav-footer{
    padding: $filter-padding;
    &__item{
      list-style: none;
      padding: rem(10px);
      &-link{
        text-decoration: none;
        @include themify($themes) {
          color: themed("primary", "base");
        }
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
</style>